import { CouponType } from '@/schema'

export type RewardType = 'promotion' | 'credit'

export interface WizardState {
	step: number
	couponType: CouponType | null
	rewardType: RewardType | null
	formData: {
		name: string
		description?: string
		requireConnectedLine?: boolean
		promotionId?: string
		creditAmount?: number
		quantity?: number
		maxQuota?: number | null
		customCode?: string
		prefix?: string
	}
}

export const WIZARD_STEPS = {
	COUPON_TYPE: 1,
	REWARD_TYPE: 2,
	CONFIGURATION: 3,
} as const
